import styled from 'styled-components';
import { getFontSize, getColorAlias } from '../../../../utils/index.js';

const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  font-weight: ${(props) => props.theme.font.weightExtrabold};
  ${getFontSize('size16')};
  color: ${getColorAlias('contentDefault')};
`;
const MonthYear = styled.span `
  justify-content: center;
  align-items: center;
  margin-left: ${(props) => (props.isLeft ? '45px' : 0)};
  margin-right: ${(props) => (props.isLeft ? 0 : '30px')};
`;
const ButtonsWrapper = styled.div `
  display: flex;
  align-items: center;
`;
const RangeButtonsWrapper = styled.div `
  display: flex;
  grid-template-columns: 50% 50%;
  align-items: center;
`;

export { ButtonsWrapper, MonthYear, RangeButtonsWrapper, Wrapper };
